<template>
  <div>
    <!-- Home Images -->
    <v-expansion-panels v-if="images.home" class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Imagens da Página Inicial</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <image-preview :src="images.home.desktop" label="Desktop" />
            <image-preview :src="images.home.tablet" label="Tablet" />
            <image-preview :src="images.home.smartphone" label="Mobile" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2" align="end">
            <v-col cols="12" md="4" class="pb-4" align="center">
              <image-picker
                :value="images.home.desktop"
                :width="1920"
                :height="780"
                :preview-rate="0.1"
                title="Desktop"
                :error="getFieldValidationError('images.home.desktop')"
                @input="updateImageField('home', 'desktop', $event)"
              />
            </v-col>
            <v-col cols="12" md="4" class="pb-4" align="center">
              <image-picker
                :value="images.home.tablet"
                :width="768"
                :height="744"
                :preview-rate="0.1"
                title="Tablet"
                @input="updateImageField('home', 'tablet', $event)"
              />
            </v-col>
            <v-col cols="12" md="4" class="pb-4" align="center">
              <image-picker
                :value="images.home.smartphone"
                :width="360"
                :height="444"
                :preview-rate="0.1"
                title="Mobile"
                @input="updateImageField('home', 'smartphone', $event)"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Form Images -->
    <v-expansion-panels v-if="images.form" class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Imagens do Formulário</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <image-preview :src="images.form.desktop" label="Desktop" />
            <image-preview :src="images.form.tablet" label="Tablet" />
            <image-preview :src="images.form.smartphone" label="Mobile" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2" align="end">
            <v-col cols="12" md="4" class="pb-4" align="center">
              <image-picker
                :value="images.form.desktop"
                :width="616"
                :height="1080"
                :preview-rate="0.1"
                title="Desktop"
                @input="updateImageField('form', 'desktop', $event)"
              />
            </v-col>
            <v-col cols="12" md="4" class="pb-4" align="center">
              <image-picker
                :value="images.form.tablet"
                :width="311"
                :height="1024"
                :preview-rate="0.1"
                title="Tablet"
                @input="updateImageField('form', 'tablet', $event)"
              />
            </v-col>
            <v-col cols="12" md="4" class="pb-4" align="center">
              <image-picker
                :value="images.form.smartphone"
                :width="150"
                :height="82"
                :preview-rate="0.5"
                title="Mobile"
                @input="updateImageField('form', 'smartphone', $event)"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <!-- Finish Images -->
    <v-expansion-panels v-if="images.finish" class="mb-4">
      <v-expansion-panel>
        <v-expansion-panel-header>
          <span class="card-title-font">Imagens da Tela de Finalização</span>
          <v-spacer />
          <div class="d-flex align-center justify-end">
            <image-preview :src="images.finish.logo" label="Logo" />
          </div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-row class="mx-n2" align="end">
            <v-col cols="12" md="4" class="pb-4" align="center">
              <image-picker
                :value="images.finish.logo"
                :width="192"
                :height="108"
                :preview-rate="0.5"
                title="Logo"
                @input="updateImageField('finish', 'logo', $event)"
              />
            </v-col>
          </v-row>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-alert v-if="loading" type="info" class="mt-4">Carregando configurações...</v-alert>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'HotsiteConfigurationImages',
  components: {
    ImagePicker: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/ImagePicker.vue'),
    ImagePreview: () => import('@/modules/configuracoes/site-de-cadastramento/views/components/ImagePreview.vue'),
  },
  data() {
    return {
      localImages: {},
    }
  },
  computed: {
    ...mapState('hotsiteConfiguration', ['loading']),
    ...mapGetters('hotsiteConfiguration', ['hasData', 'imagesWithDefaults', 'getFieldValidationError']),
    images: {
      get() {
        return this.imagesWithDefaults
      },
      set(value) {
        this.updateImages(value)
      },
    },
  },
  watch: {
    imagesWithDefaults: {
      immediate: true,
      handler(newImages) {
        this.localImages = { ...newImages }
      },
    },
  },
  methods: {
    ...mapActions('hotsiteConfiguration', ['updateImages', 'clearValidationErrors']),
    updateImageField(section, field, value) {
      // Get current images and update the specific field
      const currentImages = { ...this.images }
      if (!currentImages[section]) {
        currentImages[section] = {}
      }
      currentImages[section][field] = value

      this.updateImages(currentImages)

      // Clear validation errors when user updates a field
      this.clearValidationErrors()
    },
  },
}
</script>
